/*
 * @Author: zhao - 🍉
 * @Date: 2021-03-23 16:52:21
 * @LastEditors: zhao - 🍉
 * @LastEditTime: 2022-02-14 21:14:43
 * @Descripttion:
 */
// 首页需要放在第一个,在topMenu中有引用
/**
 * authkey : 判断身份
 * authKeyCode: 根据身份然后再判断权限. 根据@/axios/authkey.js 里的权限点
*/
export const menus = [
    { key: '/admin/salesroom', title: '门店管理',isJr: true, icon: 'shopping',  authkey: ['merchant'],
        sub: [
            { authkey: ['merchant'] ,isJr: true, authKeyCode:'l-1', key: '/admin/salesroom/list', title: '门店管理', icon: 'shopping' }
            ]
    },
    {
        key: '/admin/customer', title: '用户管理', icon: 'usergroup-add', sub: [
            { authkey: ['employee'] , authKeyCode:'b-1', key: '/admin/customer/list', title: '租客', icon: 'user' },
            { authkey: ['employee'] , authKeyCode:'b-2', key: '/admin/customer/housekeepList', title: '管家', icon: 'user' },
            { authkey: ['employee'] , authKeyCode:'n-1' , key: '/admin/customer/wechant-services', title: '微信客服', icon: 'cluster' },
            { authkey: ['employee'] , authKeyCode:'n-2' , key: '/admin/customer/customer-list', title: '微信客户列表', icon: 'cluster' },
        ]
    },
    {
        key: '/admin/house', title: '房源管理', icon: 'bank', sub: [
            { authkey: ['merchant','employee'] , authKeyCode:'c-2' , key: '/admin/house/building', title: '小区/楼栋维护', icon: 'book' },
            {  authkey: ['merchant', 'employee'], authKeyCode: 'c-4',isJr: true,key: '/admin/house/houseType', title: '户型维护', icon: 'windows', },
            {  authkey: ['merchant'], authKeyCode: 'c-5',isDevice: true,key: '/admin/house/deviceHouseType', title: '设备户型维护', icon: 'windows', },
            { authkey: ['merchant','employee'] , authKeyCode:'c-1' , key: '/admin/house/maintain', title: '房源维护', icon: 'home' },

        ]
    },
    {
        key: '/admin/rentContract', title: '租赁管理', icon: 'switcher', sub: [
            { authkey: ['merchant','employee'] , authKeyCode:'c-3' , key: '/admin/rentContract/lease', title: '房源租赁', icon: 'profile' },
            { authkey: ['merchant','employee'] , authKeyCode:'d-1' , key: '/admin/rentContract/list', title: '租客合同', icon: 'file-done' },
            { authkey: ['merchant'] , authKeyCode:'d-10' , key: '/admin/rentContract/expireList', title: '租客合同到期提醒', icon: 'file-done' },
            { authkey: ['employee'] , authKeyCode:'d-3' , key: '/admin/rentContract/template', title: '合同模板', icon: 'file-done' },
            { authkey: ['employee'] , authKeyCode:'d-4' , key: '/admin/rentContract/review', title: '合同审核', icon: 'file-done' },
        ]
    },
    {
        key: '/admin/operate', title: '运营管理', isDevice: true, icon: 'file-sync', sub: [
            { authkey: ['merchant','employee'] , authKeyCode:'z-1' ,isDevice: true, key: '/admin/operate/operateMaintain', title: '房源列表', icon: 'home' },
            { authkey: ['merchant','employee'] , authKeyCode:'z-6' ,isDevice: true, key: '/admin/operate/operateDevice', title: '设备二维码', icon: 'home' },
            { authkey: ['merchant','employee'] , authKeyCode:'z-3' , key: '/admin/operate/repairReport', title: '报修列表', icon: 'home' },
            { authkey: ['merchant','employee'] , authKeyCode:'z-4' , key: '/admin/operate/deviceBill', title: '设备账单', icon: 'home' },
            { authkey: ['merchant','employee'] , authKeyCode:'z-5' , key: '/admin/operate/billWriteOff', title: '账单核销', icon: 'home' },
            { authkey: ['merchant','employee'] , authKeyCode:'z-7' , key: '/admin/operate/payment', title: '设备收款报表', icon: 'cloud-sync' },
        ]
    },
    //finance
    {
        key: '/admin/finance', title: '财务管理', icon: 'file-sync', sub: [
            { authkey: ['merchant','employee'] , authKeyCode:'e-1' , key: '/admin/finance/billReceiv', title: '收款账单', icon: 'money-collect' },
            { authkey: ['merchant'] , authKeyCode:'e-10' , key: '/admin/finance/printBillReceipt', title: '收据打印', icon: 'money-collect' },
            { authkey: ['merchant','employee'] , authKeyCode:'e-2' , key: '/admin/finance/billPayment', title: '退款账单', icon: 'transaction' },
            { authkey: ['merchant','employee'] , authKeyCode:'f-1' , key: '/admin/finance/detailed', title: '收款明细', icon: 'euro' },
            { authkey: ['merchant','employee'] , authKeyCode:'f-2' , key: '/admin/finance/transfer', title: '项目转账', icon: 'file-search' },
            { authkey: ['merchant','employee'] , authKeyCode:'i-1' , key: '/admin/finance/payment', title: '收款报表', icon: 'cloud-sync' },
            { authkey: ['merchant','employee'] , authKeyCode:'a-1' , closable: 0, key: '/admin/finance/receiv', title: '收款提醒', icon: 'dollar' },
            { authkey: ['merchant','employee'] , authKeyCode:'e-11' , closable: 0, key: '/admin/finance/accountingRecord', title: '商户对账', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode:'e-12' , closable: 0, key: '/admin/finance/transferRecord', title: '银联划账管理', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode:'e-15' , closable: 0, key: '/admin/finance/transferRecordReminder', title: '银联划账提醒', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode: 'e-13', closable: 0, key: '/admin/finance/accountingRecordReport', title: '对账报表', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode: 'e-14', closable: 0, key: '/admin/finance/platformAccountingRecord', title: '平台对账', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode: 'e-16', closable: 0, key: '/admin/finance/hsbMerchantSplitAccount', title: '惠市宝商户分账', icon: 'dollar' },
            { authkey: ['employee'], authKeyCode: 'e-17', closable: 0, key: '/admin/finance/projectMonitoringStatistics', title: '项目监控统计', icon: 'dollar' }
        ]
    },

    {
        key: '/admin/merchant', title: '商户管理', icon: 'control', sub: [
            { authkey: ['employee'] , authKeyCode:'h-1' , key: '/admin/merchant/manage', title: '商户管理', icon: 'flag' },
            { authkey: ['merchant'] , authKeyCode:'h-2' , key: '/admin/merchant/department', title: '部门管理', icon: 'appstore' },
            { authkey: ['merchant'] , authKeyCode:'h-3' , key: '/admin/merchant/user', title: '人员管理', icon: 'user' },
            { authkey: ['merchant'] , authKeyCode:'h-4' , key: '/admin/merchant/role', title: '岗位管理', icon: 'contacts' },
            { authkey: ['employee'] , authKeyCode:'d-2' , key: '/admin/merchant/project', title: '项目管理', icon: 'file-protect' },
            { authkey: ['employee'] , authKeyCode:'z-2' , key: '/admin/merchant/acceptsHousingContract', title: '收房合同管理', icon: 'file-protect' },
            { authkey: ['employee'] , authKeyCode:'j-3' , key: '/admin/merchant/coupon', title: '优惠劵管理', icon: 'file-protect' },
            { authkey: ['employee'] , authKeyCode:'j-4' , key: '/admin/merchant/couponLog', title: '优惠劵领劵记录', icon: 'file-protect' },
            // { authkey: ['employee'] , authKeyCode:'j-8' , key: '/admin/merchant/wftPayChannel', title: '威富通支付渠道管理', icon: 'file-protect' },
            // { authkey: ['employee'] , authKeyCode:'j-9' , key: '/admin/merchant/wftPayClrgRule', title: '威富通分账配置管理', icon: 'file-protect' },
            { authkey: ['employee'] , authKeyCode:'j-5' , key: '/admin/merchant/hsbPayChannel', title: '惠市宝支付渠道管理', icon: 'file-protect' },
            { authkey: ['employee'] , authKeyCode:'j-6' , key: '/admin/merchant/hsbPayClrgRule', title: '惠市宝分账规则配置', icon: 'file-protect' },
            { authkey: ['employee'], authKeyCode: 'h-7', closable: 0, key: '/admin/merchant/hsbMarketSync', title: '惠市宝市场同步信息', icon: 'dollar' },
            // { authkey: ['employee'] , authKeyCode:'h-5' , key: '/admin/merchant/hsbMarketRule', title: '惠市宝市场分账规则', icon: 'file-protect' },
            // { authkey: ['employee'] , authKeyCode:'h-6' , key: '/admin/merchant/hsbMarketMerchant', title: '惠市宝市场商户信息', icon: 'file-protect' },


        ]
    },
    {
        key: '/admin/channel', title: '渠道管理', icon: 'apartment', sub: [
            { authkey: ['employee'] , authKeyCode:'k-1', key: '/admin/channel/manage', title: '渠道', icon: 'apartment' },
            { authkey: ['employee'] , authKeyCode:'m-1', key: '/admin/channel/customer', title: '客户', icon: 'user' },
        ]
    },
    {
        key: '/admin/employee', title: '人员管理', icon: 'team', sub: [
            { authkey: ['employee'] , authKeyCode:'g-1' , key: '/admin/employee/manage', title: '人员管理', icon: 'user' },
            { authkey: ['employee'] , authKeyCode:'g-2' , key: '/admin/employee/role', title: '岗位管理', icon: 'contacts' },
            { authkey: ['employee'] , authKeyCode:'g-3' , key: '/admin/employee/department', title: '部门管理', icon: 'appstore' }
        ]
    },
    // {
    //     key: '/admin/customer-services', title: '客服管理', icon: 'robot', sub: [
    //         { authkey: ['employee'] , authKeyCode:'n-1' , key: '/admin/customer-services/wechant-services', title: '微信客服', icon: 'cluster' },
    //         { authkey: ['employee'] , authKeyCode:'n-2' , key: '/admin/customer-services/customer-list', title: '顾客列表', icon: 'cluster' },
    //     ]
    // },
    {
        key: '/admin/other', title: '其他', icon: 'robot', sub: [
            { authkey: ['employee'] , authKeyCode:'j-1' , key: '/admin/other/short', title: '短信发送明细', icon: 'cluster' },
            { authkey: ['employee'] , authKeyCode:'j-2' , key: '/admin/other/warningList', title: '建融异常处理', icon: 'warning' },
            { authkey: ['employee'] , authKeyCode:'j-3' , key: '/admin/other/zjb-syncdata-record', title: '租金宝同步数据报表', icon: 'warning' }
        ]
    },


];



// WEBPACK FOOTER //
// ./src/layout/slideMenu/menus.js